// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"3a00e7c0","227":"fe49c6de","331":"4db6c97f","453":"99ab9532"}[chunkId] + ".chunk.js";
};